<template>
  <div>
    <h2 class="text-xs mb-10">
      {{
        $texts(
          'governmentResolutions.governmentCouncilMeetingFrom',
          'Regierungsratssitzung vom',
        )
      }}
    </h2>
    <Accordion
      v-if="group.hits.length"
      :title="group.label"
      class="!px-0"
      :always-open="isOpen"
    >
      <ul v-if="group.hits.length">
        <li
          v-for="hit in group.hits"
          :key="hit.presidentialNumber"
          class="text-base"
        >
          <NuxtLink
            :to="{
              name: 'government-resolutions-detail-page',
              params: { id: hit.presidentialNumber },
              query: { backUrl: backUrl },
            }"
            class="py-20 link block pl-25"
          >
            <div class="flex gap-5 items-center mb-8">
              <SpriteSymbol
                name="arrow-east"
                class="size-20 self-start -ml-25"
                aria-hidden="true"
              />
              <div
                class="font-bold line-clamp-2"
                v-html="hit.presidentialNumber"
              />
            </div>
            <div>{{ hit.title }}</div>
          </NuxtLink>
        </li>
      </ul>
    </Accordion>
  </div>
</template>

<script setup lang="ts">
import type { HitGroup } from '~/layers/government-resolutions/types'

const { $texts } = useNuxtApp()

defineProps<{
  group: HitGroup
  backUrl?: string
  isOpen?: boolean
}>()
</script>
